export default "__VITE_ASSET__DW98712r__"